import React from "react";
import { Select } from "antd";

import { OPTION_LABELS } from "../../../config/lang";
import { translate } from "../../../util/util";
import fieldIcon from "./fieldIcons";

export default function ChipsField({ field, value, onChange, lang }) {
  // Localize option display labels (keyed by value); fall back to the raw label.
  const options = (field.options || []).map(o => ({ value: o.value, label: translate(OPTION_LABELS, String(o.value), lang) || o.label }));
  return (
    <Select
      mode="multiple"
      prefix={fieldIcon(field)}
      /* The mockups' `+N` overflow tag is antd's own behaviour (spec/02) — don't reimplement it. */
      maxTagCount="responsive"
      options={options}
      value={value || []}
      onChange={next => onChange(field.name, next || [])}
    />
  );
}
